import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { User } from '@firebase/auth';
import { setAuth, unsetAuth } from '../../store/auth/actions';
import { createUserFromCredentials } from './index';
import { auth } from '@flow/config/firebase';

function useWatchAuth() {
  const dispatch = useDispatch();

  function onAuthStateChanged(user: User | null) {
    const set = async (user: User) => {
      const createdUser = await createUserFromCredentials(user);
      dispatch(setAuth(createdUser));
    };

    if (user) {
      set(user).catch(() => {});
    } else {
      dispatch(unsetAuth());
    }
  }

  useEffect(() => {
    const subscriber = auth.onAuthStateChanged(onAuthStateChanged);
    return subscriber; // unsubscribe on unmount
  }, []);

  return;
}

export default useWatchAuth;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/auth/use-watch-auth.ts